// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1gAi5","actions":"GroupTable_actions__2cU90","deleteModalFooter":"GroupTable_deleteModalFooter__3SixM"};